// extracted by css-extract-rspack-plugin
export default {"container":"lpvhWJs3So6rNmcJ"};